import type { Invoice, InvoiceSource } from '@/services/invoicesService'

export const INVOICE_STATUS_COLORS: Record<string, string> = {
  draft: 'bg-gray-100 text-gray-800',
  open: 'bg-blue-100 text-blue-800',
  sent: 'bg-indigo-100 text-indigo-800',
  paid: 'bg-green-100 text-green-800',
  partially_paid: 'bg-yellow-100 text-yellow-800',
  void: 'bg-red-100 text-red-800',
  uncollectible: 'bg-red-100 text-red-800',
}

export const INVOICE_SOURCE_COLORS: Record<InvoiceSource, string> = {
  manual: 'bg-slate-100 text-slate-700 border-slate-300',
  auto_from_booking: 'bg-sky-100 text-sky-800 border-sky-300',
  auto_from_encounter: 'bg-cyan-100 text-cyan-800 border-cyan-300',
  auto_from_prescription: 'bg-violet-100 text-violet-800 border-violet-300',
  auto_from_lab_order: 'bg-amber-100 text-amber-800 border-amber-300',
  subscription_refill: 'bg-fuchsia-100 text-fuchsia-800 border-fuchsia-300',
  amendment_delta: 'bg-rose-100 text-rose-800 border-rose-300',
}

export const INVOICE_SOURCE_LABELS: Record<InvoiceSource, string> = {
  manual: 'Manual',
  auto_from_booking: 'Appointment',
  auto_from_encounter: 'Encounter',
  auto_from_prescription: 'Prescription',
  auto_from_lab_order: 'Lab Order',
  subscription_refill: 'Subscription',
  amendment_delta: 'Amendment',
}

/**
 * Short context line shown next to the source badge:
 *   Prescription → treatment type
 *   Lab Order    → panel name
 *   Appointment  → appointment type name
 */
export const getInvoiceSourceContext = (invoice: Invoice): string | null => {
  switch (invoice.source) {
    case 'auto_from_prescription':
    case 'subscription_refill':
    case 'amendment_delta':
      return invoice.prescription?.treatment_type || null
    case 'auto_from_lab_order':
      return invoice.labOrder?.panel_name || null
    case 'auto_from_booking':
      return invoice.appointment?.appointmentType?.name || null
    default:
      return null
  }
}

export const formatCents = (cents: number) => `$${((cents || 0) / 100).toFixed(2)}`
